import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ProcessSummary } from "src/app/service/modulo-desempeno/proceso-desempeno.model";

/**
 * Tarjeta de un proceso de desempeño dentro del listado de selección
 * ({@link ModuloDesempenoPage}). Muestra el ícono del proceso, su tipo, nombre y
 * la cantidad de actividades pendientes. Al hacer click emite `cardClick`.
 */
@Component({
	selector: "app-proceso-desempenio-card",
	templateUrl: "./proceso-desempenio-card.component.html",
	styleUrls: ["./proceso-desempenio-card.component.scss"],
})
export class ProcesoDesempenioCardComponent {
	@Input() process!: ProcessSummary;
	@Output() cardClick = new EventEmitter<ProcessSummary>();

	onClickCard() {
		this.cardClick.emit(this.process);
	}
}
